import { ErrorName } from 'src/constants';

import { BaseError } from './BaseError';

export class NullableArgumentError extends BaseError {
  constructor({ name, value }: { name: string; value: any }) {
    super(`Argument "${name}" should not be nullable. Received value "${value}"`, {
      name: ErrorName.NullableArgument,
    });
  }
}
